import React, { useEffect, useContext, useState, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";
import ReportExcelPrintGap from "../../../components/Reports/ReportExcelPrintGap";

let groupArr = [
  // { id: 1, name: "Document No" },
  { id: 2, name: "Document Date", label: "document date" },
  { id: 3, name: "Branch", label: "branch" },
  { id: 4, name: "Customer", label: "customer" }
];

const FGSaleInvoiceReport = () => {
  const { t } = useTranslation();
  // const history = useHistory();
  //getting context values here
  let {
    loading,
    setLoading,
    dataPaginating,
    setDataPaginating,
    generalSettings,
  } = useContext(SettingsContext);
  const { branchForSearch } = useContext(RestaurantContext);
  const { authUserInfo } = useContext(UserContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRefThermal = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [option, setOption] = useState("excel");
  const [reportFields, setReportFields] = useState({
    type: "summary",
    group: groupArr[1],
    branch: null
  });

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings]);

  let common_toast = {
    position: "bottom-center",
    closeButton: false,
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  const handleOption = (e) => {
    setOption(e.target.value);
  };

  const handleBranch = (branch) => {
    setReportFields((curr)=>({...curr, branch}));
  };

  const handleSetType = (e)=>{
    setReportFields({
      ...reportFields,
      type: e.target.value
    })
  }

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `
        @page {
          margin: 15px 7px;
        }
      `,
  });

  //get excel reports filter
  const getExcelReport = () => {
    setReportData(null);
    setGeneratedReport(false);
    if (startDate !== null && endDate && reportFields.group) {
      getReport();
    } else {
      toast.error(
        `${_t(t("Please select from date, to date and group"))}`,
        common_toast
      );
    }
  };

  //get sale inv report
  const getReport = async () => {
    if (
        (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
        !reportFields?.branch?.[0]?.id
    ) {
      toast.error(`${_t(t("Please select Branch to generate report"))}`, {
      position: "bottom-center",
      closeButton: false,
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      className: "text-center toast-notification",
      });
      return;
    }
    setDataPaginating(true);
    let fromDate = moment(startDate).format("YYYY-MM-DD");
    let toDate = moment(endDate).format("YYYY-MM-DD");
    const url = BASE_URL + "/settings/finished-good-sale-invoice-report";
    const branh = reportFields?.branch?.length ? reportFields?.branch.map(brnch=> brnch.id) : "";

    let payload = {
      from_date: fromDate,
      to_date: toDate,
      branch_id: branh ?? "", 
      group_by: reportFields?.group?.label,
      type: reportFields?.type
    }
    
    // I will switch to using JSON object instead of FormData because of the array `[2,3]`.
    // Most likely the backend accepts JSON for this new endpoint.
    
    return axios
      .post(url, payload, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setGeneratedReport(true);
        setReportData(res.data); // data is usually in res.data or res.data.data
        setDataPaginating(false);
        if (option === "excel") {
          componentRef.current.handleDownload();
        } else {
          thermalPrint();
        }
      })
      .catch((error) => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`, common_toast);
      });
  };

  const header = [
    { name: "Group", key: "group_name" }, // "group_name, name:Group"
    { name: "Document Date", key: "document_date", render:(item)=> <Moment format="LL">{item.document_date}</Moment> },
    { name: "Document Identity", key: "document_identity" },
    { name: "Ref Document Identity", key: "ref_document_identity" },
    { name: "Branch Name", key: "branch_name" },
    { name: "Customer Name", key: "customer_name" },
    { name: "Total Amount", key: "total_amount", total: 1 },
    { name: "Total Discount", key: "total_discount", total: 1 },
    { name: "Total Tax", key: "total_tax", total: 1 },
    { name: "Total Advance Tax", key: "total_advance_tax", total: 1 },
    { name: "Net Total", key: "net_total", total: 1 },
    { name: "Paid Amount", key: "paid_amount", total: 1 },
    { name: "Payment Type", key: "payment_type" },
    { name: "Desc", key: "desc" },
    { name: "Is Post", key: "is_post" },
    { name: "Item Name", key: "item_name" },
    { name: "Qty", key: "qty", total: 1 },
    { name: "Rate", key: "rate" },
    { name: "Amount", key: "amount", total: 1 },
    { name: "Discount", key: "discount", total: 1 },
    { name: "Discount Percent", key: "discount_percent" },
    { name: "Tax", key: "tax", total: 1 },
    { name: "Tax Percent", key: "tax_percent" },
    { name: "Advance Tax", key: "advance_tax", total: 1 },
    { name: "Advance Tax Percent", key: "advance_tax_percent" },
    { name: "Total", key: "total", total: 1 },
  ];

  const summary = [
    { name: "Group", key: "group_name" }, 
    { name: "Document Date", key: "document_date", render:(item)=> <Moment format="LL">{item.document_date}</Moment> },
    { name: "Document Identity", key: "document_identity" },
    { name: "Ref Document Identity", key: "ref_document_identity" },
    { name: "Branch Name", key: "branch_name" },
    { name: "Customer Name", key: "customer_name" },
    { name: "Total Amount", key: "total_amount", total: 1 },
    { name: "Total Discount", key: "total_discount", total: 1 },
    { name: "Total Tax", key: "total_tax", total: 1 },
    { name: "Total Advance Tax", key: "total_advance_tax", total: 1 },
    { name: "Net Total", key: "net_total", total: 1 },
    { name: "Paid Amount", key: "paid_amount", total: 1 },
    { name: "Payment Type", key: "payment_type" },
    { name: "Desc", key: "desc" },
  ];

  return (
    <>
      <Helmet>
        <title>{_t(t("Fg Sale Invoice Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename={"Fg Sale Invoice Report"}
        sheet="sheet 1"
        buttonText="Fg Sale Detail"
        ref={componentRef}
      />

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating} />

                    {/* spin loading ends */}

                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Fg Sale Invoice Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end">
                            <ReportTypeOptions
                              selectedOption={option}
                              onChange={handleOption}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-2 d-block">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2 d-block">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>
                        <div className="col-3">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={reportFields.branch}
                            styles={customStyle}
                            isClearable
                            isMulti
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>
                        <div className="col-2">
                          <Select
                            options={groupArr && groupArr}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={reportFields.group}
                            styles={customStyle}
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={(group) => setReportFields((curr)=>({...curr, group}))}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select group")) + ".."}
                          />
                        </div>
                         <div className="col-3">
                            <div className="mt-0">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="summary"
                                name="type"
                                value="summary"
                                onChange={(e) => handleSetType(e)}
                                checked={reportFields.type === "summary"}
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2"
                                htmlFor="summary"
                              >
                                {_t(t("Summary"))}
                              </label>
                            </div>

                            <div className="mt-1">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="detail"
                                name="detail"
                                value="detail"
                                onChange={(e) => handleSetType(e)}
                                checked={reportFields.type === "detail"}
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2"
                                htmlFor="detail"
                              >
                                {_t(t("Detail"))}
                              </label>
                            </div>
                          </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-10"></div>
                         <div className="col-2 t-mb-15 mb-md-0 text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => getExcelReport()}
                          >
                            GENERATE REPORT
                          </button>
                        </div>
                      </div>
                      <ReportExcelPrintGap
                        header={reportFields.type === "summary" ? summary : header}
                        generatedReport = {generatedReport}
                        heading={"Fg Sale Invoice Report"}
                        reportData={reportData}
                        startDate={startDate}
                        endDate={endDate}
                        componentRef={componentRef}
                        printRef={componentRefThermal}
                        branch={{
                          name: "",
                          show: false,
                        }}
                        type = {option}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default FGSaleInvoiceReport;
